const store = {
  namespaced: true,
  state: {},
  getters: {},
  mutations: {},
  actions: {
    async batchUpdateVehicleStatus({ rootState }, params) {
      const data = await rootState.http("/customer/batchUpdateVehicleStatus", params);
      return data;
    },
    async addInsure({ rootState }, params = {}) {
      const data = await rootState.http("/insurer/addInsurer", params);
      return data;
    },
    async queryInsureList({ rootState }, params = {}) {
      const data = await rootState.http("/insurer/queryInsurerList", params);
      return data;
    },
    async getCustomerList({ rootState }, params = {}) {
      const data = await rootState.http("/customer/queryCustomerList", params);
      return data;
    },
    async createCustomer({ rootState }, params = {}) {
      const data = await rootState.http("/customer/createCustomer", params);
      return data;
    },
    async saveCustomer({ rootState }, params = {}) {
      const data = await rootState.http("/customer/saveCustomer", params);
      return data;
    },
    async getCustomerDetail({ rootState }, params = {}) {
      const data = await rootState.http("/customer/getCustomer", params);
      return data;
    },
    async updateCustomer({ rootState }, params = {}) {
      const data = await rootState.http("/customer/updateCustomer", params);
      return data;
    },
    async getCustomerExpensesRecord({ rootState }, params = {}) {
      const data = await rootState.http("/order/queryCustomerExpensesRecord", params);
      return data;
    },
    async updateCustomerStatus({ rootState }, params = {}) {
      const data = await rootState.http("/customer/batchUpdateCustomerStatus", params);
      return data;
    },
    async updateVehicleOwner({ rootState }, params = {}) {
      const data = await rootState.http("/customer/changeVehicleOwner", params);
      return data;
    },
    async queryCustomerConsumeList({ rootState }, params = {}) {
      const data = await rootState.http("/order/queryCustomerExpensesSimpleRecordSummary", params);
      return data;
    }
  }
};

export default store;
